export const fieldFindRegExp = /\{\{(.*?)\}\}/g
export const dateNowRegExp = /DATENOW\((.*?)\)/g
export const fieldReplaceRegExp = /^\{\{|\}\}$/g
export const fieldConnector = '-_-'
export const tableAndFieldConnector = '-->'

export const compact = (array) => {
  let index = -1,
    length = array == null ? 0 : array.length,
    resIndex = 0,
    result = []

  while (++index < length) {
    let value = array[index]
    if (value) {
      result[resIndex++] = value
    }
  }
  return result
}
